import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, FeaturesConfigModule, I18nModule, provideDefaultConfig, UrlModule } from '@spartacus/core';
import {
  AtMessageModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  OutletModule,
  PageComponentModule,
  ProductListItemContextSource,
  ProductListModule,
  SpinnerModule,
  StarRatingModule,
  MediaModule
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GonvarriProductListComponent } from '../../components/gonvarri-product-list/gonvarri-product-list.component';
import { GonvarriProductGridItemModule } from '../gonvarri-product-grid-item/gonvarri-product-grid-item.module';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    GonvarriProductListComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    AtMessageModule,
    GonvarriProductGridItemModule
  ],
  providers: [
    ProductListItemContextSource,
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        SearchResultsListComponent: {
          component: GonvarriProductListComponent,
        },
        CMSProductListComponent: {
          component: GonvarriProductListComponent,
        },
        ProductGridComponent: {
          component: GonvarriProductListComponent,
        },
      },
    }),
  ],
  exports: [
    GonvarriProductListComponent
  ]
})
export class GonvarriProductListModule {}
